var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',[_c('main',{staticClass:"container"},[_c('Documents'),(_vm.currentTab === 'tab4')?_c('div',[_c('AdvancedSearchForm')],1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }